import { render, staticRenderFns } from "./SpatialFilterControl.vue?vue&type=template&id=081a837e&scoped=true&"
import script from "./SpatialFilterControl.vue?vue&type=script&lang=js&"
export * from "./SpatialFilterControl.vue?vue&type=script&lang=js&"
import style0 from "./SpatialFilterControl.vue?vue&type=style&index=0&id=081a837e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a837e",
  null
  
)

export default component.exports